import request from '@/services/base-service';
import type { KnowledgeDTO, AccessKienThucView, KnowledgeListData, RequestSDK, KnowledgeModel } from '@/types/knowledge';
import type { RequestDTO } from '@/types/requestDTO';
import { InternalAxiosRequestConfig } from 'axios';


const baseUrl = `/v1/knowledge`;

export const knowledgeApi = {
  // Main list endpoint matching KnowledgeController.List
  list: (requestDTO: RequestDTO) =>
    request.post(`${baseUrl}/list`, requestDTO, { authorization: true } as InternalAxiosRequestConfig),

  create: (data: Partial<KnowledgeDTO>) =>
    request.post<{ success: boolean; data: KnowledgeDTO; message?: string }>(`${baseUrl}`, data, {
      authorization: true,
    } as InternalAxiosRequestConfig),

  update: (id: string, data: KnowledgeDTO | KnowledgeModel) =>
    request.put(`${baseUrl}`, data, { params: { id }, authorization: true } as InternalAxiosRequestConfig),

  delete: (id: string | number) =>
    request.delete(`${baseUrl}/${id}`, { authorization: true } as InternalAxiosRequestConfig),

  listKnowledge: (requestDTO: RequestDTO) =>
    request.post<KnowledgeListData>(`${baseUrl}/list`, requestDTO, { authorization: true } as InternalAxiosRequestConfig),

  // Get list by category matching KnowledgeController.GetListKienThucLoai
  getListKienThucLoai: (requestSDK: RequestSDK) =>
    request.post<AccessKienThucView>(`${baseUrl}/getlistkienthucloai`, requestSDK, {
      authorization: true
    } as InternalAxiosRequestConfig),
};



